<template>
  <Modal @close="$emit('close')">
    <template #header>
      <div class="w-full text-center">
        <h1 class="text-2xl">
          {{ $t('SelfPerform.PlantDashboard.PlantUtilisationReport.title') }}
        </h1>
      </div>
    </template>

    <template #body>
      <div class="flex justify-center w-full flex-col space-y-4">
        <label>
          {{ $t('SelfPerform.PlantDashboard.PlantUtilisationReport.label.start') }}

          <AppInput
            v-model="reportStart"
            name="start"
            type="date"
            data-test="start"
            class="form-input"
          />
        </label>

        <label>
          {{ $t('SelfPerform.PlantDashboard.PlantUtilisationReport.label.end') }}

          <AppInput
            v-model="reportEnd"
            name="end"
            type="date"
            data-test="end"
            class="form-input"
          />
        </label>
      </div>
    </template>

    <template #footer>
      <div class="flex justify-end">
        <button
          type="button"
          class="btn btn--secondary-blue"
          @click.prevent="$emit('close')"
        >
          {{ $t('SelfPerform.PlantDashboard.PlantUtilisationReport.button.cancel') }}
        </button>

        <a
          v-if="reportStart && reportEnd && reportStart < reportEnd"
          :href="reportUrl"
          target="_blank"
          class="btn btn--primary-blue ml-2"
          @click="$emit('close')"
        >
          {{ $t('SelfPerform.PlantDashboard.PlantUtilisationReport.button.getReport') }}
        </a>

        <button
          v-else
          type="button"
          class="btn btn--primary-blue ml-2"
          disabled
        >
          {{ $t('SelfPerform.PlantDashboard.PlantUtilisationReport.button.getReport') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import { useProjectsStore } from '@/store/projects';
import { computed, ref } from 'vue';

defineEmits<{
  (e: 'close');
}>();

const reportStart = ref();
const reportEnd = ref();
const projectsStore = useProjectsStore();

const reportUrl = computed(() => {
  return `/api/v1/projects/${projectsStore.project?.id}/plant-utilisation?start=${reportStart.value}&end=${reportEnd.value}`;
});
</script>

<style scoped></style>
